export default __webpack_public_path__ + "static/media/fusion-power-logo.55b2269a.png";